import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { UserApiService } from '../api';
import { GetUserRes, UpdateUserRes } from '../models';
import { userMock } from './user.mock';

@Injectable()
export class UserMockApiService extends UserApiService {
  override getUser(): Observable<GetUserRes> {
    const account = userMock();

    return of(account).pipe(delay(500));
  }

  override updateUser(): Observable<UpdateUserRes> {
    return of(null).pipe(delay(500));
  }
}
